import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNfc1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconNfc1"><Path d="M6.96875 7.208C8.13262 8.48008 8.84023 10.1594 8.84023 12.0003C8.84023 13.8411 8.13261 15.5205 6.96875 16.7925M10.3402 4.7364C12.028 6.70065 13.0445 9.23443 13.0445 12.0003C13.0445 14.7661 12.028 17.2999 10.3402 19.2641M13.3495 2.53027C15.7774 5.06029 17.2487 8.37352 17.2487 12.0003C17.2487 15.627 15.7774 18.9403 13.3495 21.4703" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconNfc1;
